import styled from 'styled-components'

import { ButtonInlineUnstyled } from 'Components/Buttons/ButtonInline/unstyled'

export const ButtonInline = styled(ButtonInlineUnstyled)`
  fill: ${props => props.theme.colors.regentGray};
  font-size: ${props => props.theme.fontSizes.city.card.link};
  color: ${props =>
    props.labelColor ? props.labelColor : props.theme.colors.regentGray};
  display: flex;
  line-height: 16px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  & > div {
    display: flex;
  }

  svg {
    height: 15px;
    width: 18px;
    margin-right: 7px;
  }
`
